/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Reportinghistory_Nodata3Inputs */

const en_coinvestments_report_reportinghistory_nodata3 = /** @type {(inputs: Coinvestments_Report_Reportinghistory_Nodata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No reporting history yet.`)
};

/**
* | output |
* | --- |
* | "No reporting history yet." |
*
* @param {Coinvestments_Report_Reportinghistory_Nodata3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_reportinghistory_nodata3 = /** @type {((inputs?: Coinvestments_Report_Reportinghistory_Nodata3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Reportinghistory_Nodata3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_reportinghistory_nodata3(inputs)
});
export { coinvestments_report_reportinghistory_nodata3 as "coInvestments_report_reportingHistory_noData" }